import React, { useEffect, useState } from "react";
import Repo from "../../Repository/Repo";

function useGetProperties() {
  const companyCode = localStorage.getItem("companyCode");
  const [loading, setLoading] = useState(false);
  const [records, setRecords] = useState([]);

  useEffect(() => {
    if (companyCode == 4416 || companyCode == 9478) {
      onGet();
    }
  }, []);

  const onAdd = (e) => {
    setRecords((prev) => [e, ...prev]);
  };
  const onRem = (id) => {
    let copy = JSON.parse(JSON.stringify(records));

    let found = copy.findIndex((i) => i._id == id);
    if (found != -1) {
      copy.splice(found, 1);
      setRecords(copy);
    }
  };

  const onUpdate = (e) => {
    let copy = JSON.parse(JSON.stringify(records));
    let found = copy.find((i) => i._id == e._id);
    if (found) {
      found.sr = e.sr;
      found.sellerName = e.sellerName;
      found.purchaserName = e.purchaserName;
      found.documentNo = e.documentNo;
      found.pics = e.pics;
      found.received = e.received;
      found.totalAmount = e.totalAmount;
      found.status = e.status;
      found.detailRegistry = e.detailRegistry;
      found.balance = e.balance;
    }
    setRecords(copy);
  };

  const onGet = async () => {
    try {
      setLoading(true);
      let { data } = await Repo.property({
        request: {
          method: "getAgreementsByCompany",
          data: {
            company_code: localStorage.getItem("companyCode"),
          },
        },
      });
      setLoading(false);
      if (data.response.status.statusCode == 200) {
        setRecords(data.response.data.agreementArr);
      } else {
        Toast("error", data.response.status.statusMessage);
      }
    } catch (err) {
      console.log("err:", err);
      setLoading(false);
    }
  };

  return { loading, records, onRem, onGet, onUpdate, onAdd };
}

export default useGetProperties;
